// Generated TypeScript types from Pydantic models
// Source: src/backend/models.py
// Generated on: 2026-06-29T09:36:18.093467
// DO NOT EDIT MANUALLY - This file is auto-generated

// ============================
// Enums
// ============================

export type AIModelType = "qwen2.5" | "flux-schnell";

export type ActivityType = "login" | "search" | "view_job" | "apply_job" | "message" | "update_profile" | "chat";

export type ApiActivityType = "system" | "info" | "searching" | "thinking" | "generating" | "converting" | "generating_image" | "tooling" | "heartbeat";

export type ApiMessageType = "binary" | "text" | "json";

export type ApiStatusType = "streaming" | "status" | "done" | "error";

export type ApplicationStatus = "applied" | "reviewing" | "interview" | "offer" | "rejected" | "accepted" | "withdrawn";

export type ChatContextType = "job_search" | "job_requirements" | "candidate_chat" | "interview_prep" | "resume_chat" | "resume_review" | "edit_resume" | "general" | "generate_persona" | "generate_profile" | "generate_resume" | "generate_image" | "rag_search" | "skill_match";

export type ChatSenderType = "user" | "assistant" | "system" | "information" | "warning" | "error";

export type ColorBlindMode = "protanopia" | "deuteranopia" | "tritanopia" | "none";

export type DataSourceType = "document" | "website" | "api" | "database" | "internal";

export type DocumentType = "pdf" | "docx" | "txt" | "markdown" | "image";

export type EmploymentType = "full-time" | "part-time" | "contract" | "internship" | "freelance";

export type FontSize = "small" | "medium" | "large";

export type InterviewRecommendation = "strong_hire" | "hire" | "no_hire" | "strong_no_hire";

export type InterviewType = "phone" | "video" | "onsite" | "technical" | "behavioral";

export type LanguageProficiency = "basic" | "conversational" | "fluent" | "native";

export type MFAMethod = "app" | "sms" | "email";

export type NotificationType = "email" | "push" | "in_app";

export type ProcessingStepType = "extract" | "transform" | "chunk" | "embed" | "filter" | "summarize";

export type SalaryPeriod = "hour" | "day" | "month" | "year";

export type SearchType = "similarity" | "mmr" | "hybrid" | "keyword";

export type SkillLevel = "beginner" | "intermediate" | "advanced" | "expert";

export type SkillStatus = "pending" | "complete" | "waiting" | "error";

export type SkillStrength = "strong" | "moderate" | "weak" | "none" | "unknown";

export type SocialPlatform = "linkedin" | "twitter" | "github" | "dribbble" | "behance" | "website" | "other";

export type SortOrder = "asc" | "desc";

export type ThemePreference = "light" | "dark" | "system";

export type UserGender = "female" | "male";

export type UserStatus = "active" | "inactive" | "pending" | "banned";

export type UserType = "candidate" | "employer" | "guest";

export type VectorStoreType = "chroma";

// ============================
// Interfaces
// ============================

export interface AccessibilitySettings {
  fontSize: "small" | "medium" | "large";
  highContrast: boolean;
  reduceMotion: boolean;
  screenReader: boolean;
  colorBlindMode?: "protanopia" | "deuteranopia" | "tritanopia" | "none";
}

export interface Analytics {
  id?: string;
  entityType: "job" | "candidate" | "chat" | "system" | "employer";
  entityId: string;
  metricType: string;
  value: number;
  timestamp: Date;
  dimensions?: Record<string, any>;
  segment?: string;
}

export interface ApiMessage {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
}

export interface ApiResponse {
  success: boolean;
  data?: any;
  error?: ErrorDetail;
  meta?: Record<string, any>;
}

export interface ApplicationDecision {
  status: "accepted" | "rejected";
  reason?: string;
  date: Date;
  by: string;
}

export interface Attachment {
  id?: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  fileUrl: string;
  uploadedAt: Date;
  isProcessed: boolean;
  processingResult?: any;
  thumbnailUrl?: string;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: Candidate | Employer | Guest;
  expiresAt: number;
  userType?: string;
  isGuest?: boolean;
}

export interface Authentication {
  userId: string;
  passwordHash: string;
  salt: string;
  refreshTokens: Array<RefreshToken>;
  resetPasswordToken?: string;
  resetPasswordExpiry?: Date;
  lastPasswordChange: Date;
  mfaEnabled: boolean;
  mfaMethod?: "app" | "sms" | "email";
  mfaSecret?: string;
  loginAttempts: number;
  lockedUntil?: Date;
}

export interface BaseUser {
  userType: "candidate" | "employer" | "guest";
  id?: string;
  lastActivity?: Date;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phone?: string;
  location?: Location;
  createdAt?: Date;
  updatedAt?: Date;
  lastLogin?: Date;
  profileImage?: string;
  status: "active" | "inactive" | "pending" | "banned";
  isAdmin: boolean;
}

export interface BaseUserWithType {
  userType: "candidate" | "employer" | "guest";
  id?: string;
  lastActivity?: Date;
}

export interface Candidate {
  userType: "candidate" | "employer" | "guest";
  id?: string;
  lastActivity?: Date;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phone?: string;
  location?: Location;
  createdAt?: Date;
  updatedAt?: Date;
  lastLogin?: Date;
  profileImage?: string;
  status: "active" | "inactive" | "pending" | "banned";
  isAdmin: boolean;
  username: string;
  description?: string;
  resume?: string;
  skills?: Array<Skill>;
  experience?: Array<WorkExperience>;
  questions?: Array<CandidateQuestion>;
  education?: Array<Education>;
  preferredJobTypes?: Array<"full-time" | "part-time" | "contract" | "internship" | "freelance">;
  desiredSalary?: DesiredSalary;
  availabilityDate?: Date;
  summary?: string;
  languages?: Array<Language>;
  certifications?: Array<Certification>;
  jobApplications?: Array<JobApplication>;
  rags?: Array<RagEntry>;
  ragContentSize: number;
  isPublic: boolean;
}

export interface CandidateAI {
  userType: "candidate" | "employer" | "guest";
  id?: string;
  lastActivity?: Date;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phone?: string;
  location?: Location;
  createdAt?: Date;
  updatedAt?: Date;
  lastLogin?: Date;
  profileImage?: string;
  status: "active" | "inactive" | "pending" | "banned";
  isAdmin: boolean;
  username: string;
  description?: string;
  resume?: string;
  skills?: Array<Skill>;
  experience?: Array<WorkExperience>;
  questions?: Array<CandidateQuestion>;
  education?: Array<Education>;
  preferredJobTypes?: Array<"full-time" | "part-time" | "contract" | "internship" | "freelance">;
  desiredSalary?: DesiredSalary;
  availabilityDate?: Date;
  summary?: string;
  languages?: Array<Language>;
  certifications?: Array<Certification>;
  jobApplications?: Array<any>;
  rags?: Array<RagEntry>;
  ragContentSize: number;
  isPublic: boolean;
  isAI: boolean;
  age?: number;
  gender?: "female" | "male";
  ethnicity?: string;
}

export interface CandidateContact {
  email: string;
  phone?: string;
}

export interface CandidateListResponse {
  success: boolean;
  data?: Array<Candidate>;
  error?: ErrorDetail;
  meta?: Record<string, any>;
}

export interface CandidateQuestion {
  question: string;
  tunables?: Tunables;
}

export interface CandidateResponse {
  success: boolean;
  data?: Candidate;
  error?: ErrorDetail;
  meta?: Record<string, any>;
}

export interface Certification {
  id?: string;
  name: string;
  issuingOrganization: string;
  issueDate: Date;
  expirationDate?: Date;
  credentialId?: string;
  credentialUrl?: string;
}

export interface ChatContext {
  type: "job_search" | "job_requirements" | "candidate_chat" | "interview_prep" | "resume_chat" | "resume_review" | "edit_resume" | "general" | "generate_persona" | "generate_profile" | "generate_resume" | "generate_image" | "rag_search" | "skill_match";
  relatedEntityId?: string;
  relatedEntityType?: "job" | "candidate" | "employer";
  additionalContext?: Record<string, any>;
}

export interface ChatMessage {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  role: "user" | "assistant" | "system" | "information" | "warning" | "error";
  content: string;
  extraContext?: ExtraChatContext;
  tunables?: Tunables;
  metadata: ChatMessageMetaData;
}

export interface ChatMessageError {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  content: string;
}

export interface ChatMessageMetaData {
  model: "qwen2.5" | "flux-schnell";
  temperature: number;
  maxTokens: number;
  topP: number;
  frequencyPenalty: number;
  presencePenalty: number;
  stopSequences: Array<string>;
  ragResults?: Array<ChromaDBGetResponse>;
  llmHistory?: Array<any>;
  usage?: UsageStats;
  options?: ChatOptions;
  tools?: Tool;
  timers?: Record<string, number>;
}

export interface ChatMessageRagSearch {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  dimensions: number;
  content: Array<ChromaDBGetResponse>;
}

export interface ChatMessageResume {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  role: "user" | "assistant" | "system" | "information" | "warning" | "error";
  content: string;
  extraContext?: ExtraChatContext;
  tunables?: Tunables;
  metadata: ChatMessageMetaData;
  resume: Resume;
}

export interface ChatMessageSkillAssessment {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  role: "user" | "assistant" | "system" | "information" | "warning" | "error";
  content: string;
  extraContext?: ExtraChatContext;
  tunables?: Tunables;
  metadata: ChatMessageMetaData;
  skillAssessment: SkillAssessment;
}

export interface ChatMessageStatus {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  activity: "system" | "info" | "searching" | "thinking" | "generating" | "converting" | "generating_image" | "tooling" | "heartbeat";
  content: any;
}

export interface ChatMessageStreaming {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  content: string;
}

export interface ChatMessageUser {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  role: "user" | "assistant" | "system" | "information" | "warning" | "error";
  content: string;
  extraContext?: ExtraChatContext;
  tunables?: Tunables;
}

export interface ChatOptions {
  seed?: number;
  numCtx?: number;
  maxTokens?: number;
  temperature?: number;
  topP?: number;
  presencePenalty?: number;
  frequencyPenalty?: number;
}

export interface ChatQuery {
  prompt: string;
  tunables?: Tunables;
  agentOptions?: Record<string, any>;
}

export interface ChatResponse {
  content: string;
  model: string;
  finishReason?: string;
  reasoning: string;
  usage?: UsageStats;
  usage_dict?: Record<string, number>;
}

export interface ChatSession {
  id?: string;
  userId?: string;
  guestId?: string;
  createdAt?: Date;
  lastActivity?: Date;
  title?: string;
  context: ChatContext;
  isArchived: boolean;
  systemPrompt?: string;
}

export interface ChromaDBGetResponse {
  ids: Array<string>;
  embeddings: Array<Array<number>>;
  documents: Array<string>;
  metadatas: Array<Record<string, any>>;
  distances: Array<number>;
  name: string;
  size: number;
  dimensions: number;
  query: string;
  queryEmbedding?: Array<number>;
  umapEmbedding2D?: Array<number>;
  umapEmbedding3D?: Array<number>;
}

export interface CreateCandidateRequest {
  email: string;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  phone?: string;
}

export interface CreateEmployerRequest {
  email: string;
  username: string;
  password: string;
  companyName: string;
  industry: string;
  companySize: string;
  companyDescription: string;
  websiteUrl?: string;
  phone?: string;
}

export interface CustomQuestion {
  question: string;
  answer: string;
}

export interface DataSourceConfiguration {
  id?: string;
  ragConfigId: string;
  name: string;
  sourceType: "document" | "website" | "api" | "database" | "internal";
  connectionDetails: Record<string, any>;
  processingPipeline: Array<ProcessingStep>;
  refreshSchedule?: string;
  lastRefreshed?: Date;
  status: "active" | "pending" | "error" | "processing";
  errorDetails?: string;
  metadata?: Record<string, any>;
}

export interface DesiredSalary {
  amount: number;
  currency: string;
  period: "hour" | "day" | "month" | "year";
}

export interface Document {
  id?: string;
  ownerId: string;
  filename: string;
  originalName: string;
  type: "pdf" | "docx" | "txt" | "markdown" | "image";
  size: number;
  uploadDate?: Date;
  updatedAt?: Date;
  options?: DocumentOptions;
  ragChunks?: number;
}

export interface DocumentContentResponse {
  documentId: string;
  filename: string;
  type: "pdf" | "docx" | "txt" | "markdown" | "image";
  content: string;
  size: number;
}

export interface DocumentListResponse {
  documents: Array<Document>;
  total: number;
}

export interface DocumentMessage {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  document: Document;
  content?: string;
  converted: boolean;
}

export interface DocumentOptions {
  includeInRag: boolean;
  isJobDocument?: boolean;
  overwrite?: boolean;
}

export interface DocumentUpdateRequest {
  filename?: string;
  content?: string;
  options?: DocumentOptions;
}

export interface EditHistory {
  content: string;
  editedAt: Date;
  editedBy: string;
}

export interface Education {
  id?: string;
  institution: string;
  degree: string;
  fieldOfStudy: string;
  startDate: Date;
  endDate?: Date;
  isCurrent: boolean;
  gpa?: number;
  achievements?: Array<string>;
  location?: Location;
}

export interface EmailVerificationRequest {
  token: string;
}

export interface Employer {
  userType: "candidate" | "employer" | "guest";
  id?: string;
  lastActivity?: Date;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phone?: string;
  location?: Location;
  createdAt?: Date;
  updatedAt?: Date;
  lastLogin?: Date;
  profileImage?: string;
  status: "active" | "inactive" | "pending" | "banned";
  isAdmin: boolean;
  companyName: string;
  industry: string;
  description?: string;
  companySize: string;
  companyDescription: string;
  websiteUrl?: string;
  jobs?: Array<Job>;
  companyLogo?: string;
  socialLinks?: Array<SocialLink>;
  poc?: PointOfContact;
}

export interface EmployerResponse {
  success: boolean;
  data?: Employer;
  error?: ErrorDetail;
  meta?: Record<string, any>;
}

export interface ErrorDetail {
  code: string;
  message: string;
  details?: any;
}

export interface EvidenceDetail {
  source: string;
  quote: string;
  context: string;
}

export interface ExtraChatContext {
  jobId?: string;
  candidateId?: string;
  resumeId?: string;
  resume?: string;
  isAnswer?: boolean;
}

export interface GPUInfo {
  name: string;
  memory: number;
  discrete: boolean;
}

export interface Guest {
  userType: "candidate" | "employer" | "guest";
  id?: string;
  lastActivity?: Date;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phone?: string;
  location?: Location;
  createdAt?: Date;
  updatedAt?: Date;
  lastLogin?: Date;
  profileImage?: string;
  status: "active" | "inactive" | "pending" | "banned";
  isAdmin: boolean;
  sessionId: string;
  username: string;
  convertedToUserId?: string;
  ipAddress?: string;
  userAgent?: string;
  ragContentSize: number;
  isPublic: boolean;
}

export interface GuestCleanupRequest {
  inactiveHours: number;
}

export interface GuestConversionRequest {
  accountType: "candidate" | "employer";
  email: string;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  phone?: string;
  companyName?: string;
  industry?: string;
  companySize?: string;
  companyDescription?: string;
  websiteUrl?: string;
}

export interface GuestSessionResponse {
  accessToken: string;
  refreshToken: string;
  user: Guest;
  expiresAt: number;
  userType: "guest";
  isGuest: boolean;
}

export interface GuestStatistics {
  totalGuests: number;
  activeLastHour: number;
  activeLastDay: number;
  convertedGuests: number;
  byIp: Record<string, number>;
  creationTimeline: Record<string, number>;
}

export interface InterviewFeedback {
  id?: string;
  interviewId: string;
  reviewerId: string;
  technicalScore: number;
  culturalScore: number;
  overallScore: number;
  strengths: Array<string>;
  weaknesses: Array<string>;
  recommendation: "strong_hire" | "hire" | "no_hire" | "strong_no_hire";
  comments: string;
  createdAt?: Date;
  updatedAt?: Date;
  isVisible: boolean;
  skillAssessments?: Array<SkillAssessment>;
}

export interface InterviewSchedule {
  id?: string;
  applicationId: string;
  scheduledDate: Date;
  endDate: Date;
  interviewType: "phone" | "video" | "onsite" | "technical" | "behavioral";
  interviewers: Array<string>;
  location?: string | Location;
  notes?: string;
  feedback?: InterviewFeedback;
  status: "scheduled" | "completed" | "cancelled" | "rescheduled";
  meetingLink?: string;
}

export interface Job {
  id?: string;
  ownerId: string;
  ownerType: "candidate" | "employer" | "guest";
  owner?: BaseUser;
  title?: string;
  summary?: string;
  company?: string;
  payMinimum?: string;
  payMaximum?: string;
  description: string;
  requirements?: JobRequirements;
  createdAt?: Date;
  updatedAt?: Date;
  details?: JobDetails;
}

export interface JobAnalysis {
  jobId: string;
  candidateId: string;
  skills: Array<SkillAssessment>;
}

export interface JobApplication {
  id?: string;
  jobId: string;
  candidateId: string;
  status: "applied" | "reviewing" | "interview" | "offer" | "rejected" | "accepted" | "withdrawn";
  appliedDate: Date;
  updatedDate: Date;
  resumeVersion: string;
  coverLetter?: string;
  notes?: string;
  interviewSchedules?: Array<InterviewSchedule>;
  customQuestions?: Array<CustomQuestion>;
  candidateContact?: CandidateContact;
  decision?: ApplicationDecision;
}

export interface JobDetails {
  location: Location;
  salaryRange?: SalaryRange;
  employmentType: "full-time" | "part-time" | "contract" | "internship" | "freelance";
  datePosted?: Date;
  applicationDeadline?: Date;
  isActive: boolean;
  applicants?: Array<any>;
  department?: string;
  reportsTo?: string;
  benefits?: Array<string>;
  visaSponsorship?: boolean;
  featuredUntil?: Date;
  views: number;
  applicationCount: number;
}

export interface JobListResponse {
  success: boolean;
  data?: Array<Job>;
  error?: ErrorDetail;
  meta?: Record<string, any>;
}

export interface JobRequirements {
  technicalSkills: Requirements;
  experienceRequirements: Requirements;
  softSkills?: Array<string>;
  experience?: Array<string>;
  education?: Array<string>;
  certifications?: Array<string>;
  preferredAttributes?: Array<string>;
  companyValues?: Array<string>;
}

export interface JobRequirementsExtraction {
  companyName: string;
  jobTitle: string;
  jobSummary: string;
  payMinimum?: string;
  payMaximum?: string;
  jobRequirements: JobRequirements;
}

export interface JobRequirementsMessage {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  job: Job;
}

export interface JobResponse {
  success: boolean;
  data?: Job;
  error?: ErrorDetail;
  meta?: Record<string, any>;
}

export interface Language {
  language: string;
  proficiency: "basic" | "conversational" | "fluent" | "native";
}

export interface Location {
  text: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
  latitude?: number;
  longitude?: number;
  remote?: boolean;
  hybridOptions?: Array<string>;
  address?: string;
}

export interface LoginRequest {
  login: string;
  password: string;
}

export interface MFAData {
  message: string;
  deviceId: string;
  deviceName: string;
  codeSent: string;
  email: string;
}

export interface MFARequest {
  username: string;
  password: string;
  deviceId: string;
  deviceName: string;
  email: string;
}

export interface MFARequestResponse {
  mfaRequired: boolean;
  mfaData?: MFAData;
}

export interface MFAVerifyRequest {
  email: string;
  code: string;
  deviceId: string;
  rememberDevice: boolean;
}

export interface MessageReaction {
  userId: string;
  reaction: string;
  timestamp: Date;
}

export interface NotificationPreference {
  type: "email" | "push" | "in_app";
  events: Array<string>;
  isEnabled: boolean;
}

export interface PaginatedRequest {
  page: number;
  limit: number;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  filters?: Record<string, any>;
}

export interface PaginatedResponse {
  data: Array<any>;
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasMore: boolean;
}

export interface PersonaExtraction {
  firstName: string;
  lastName: string;
  fullName: string;
  username: string;
  description: string;
  title: string;
  phone: string;
  location: string;
  email: string;
}

export interface PointOfContact {
  name: string;
  position: string;
  email: string;
  phone?: string;
}

export interface ProcessingStep {
  id?: string;
  type: "extract" | "transform" | "chunk" | "embed" | "filter" | "summarize";
  parameters: Record<string, any>;
  order: number;
  dependsOn?: Array<string>;
}

export interface RAGConfiguration {
  id?: string;
  userId: string;
  name: string;
  description?: string;
  dataSourceConfigurations: Array<DataSourceConfiguration>;
  embeddingModel: string;
  vectorStoreType: "chroma";
  retrievalParameters: RetrievalParameters;
  createdAt?: Date;
  updatedAt?: Date;
  version: number;
  isActive: boolean;
}

export interface RAGDocumentRequest {
  id: string;
}

export interface RagContentMetadata {
  sourceFile: string;
  lineBegin: number;
  lineEnd: number;
  lines: number;
  chunkBegin?: number;
  chunkEnd?: number;
  metadata?: Record<string, any>;
}

export interface RagContentResponse {
  id: string;
  content: string;
  metadata: RagContentMetadata;
}

export interface RagEntry {
  name: string;
  description: string;
  enabled: boolean;
}

export interface RateLimitConfig {
  requestsPerMinute: number;
  requestsPerHour: number;
  requestsPerDay: number;
  burstLimit: number;
  burstWindowSeconds: number;
}

export interface RateLimitResult {
  allowed: boolean;
  reason?: string;
  retryAfterSeconds?: number;
  remainingRequests?: Record<string, number>;
  resetTimes?: Record<string, Date>;
}

export interface RateLimitStatus {
  userId: string;
  userType: string;
  isAdmin: boolean;
  currentUsage: Record<string, number>;
  limits: Record<string, number>;
  remaining: Record<string, number>;
  resetTimes: Record<string, Date>;
  config: RateLimitConfig;
}

export interface RefreshToken {
  token: string;
  expiresAt: Date;
  device: string;
  ipAddress: string;
  isRevoked: boolean;
  revokedReason?: string;
}

export interface Requirements {
  required?: Array<string>;
  preferred?: Array<string>;
}

export interface ResendVerificationRequest {
  email: string;
}

export interface Resume {
  id?: string;
  jobId: string;
  candidateId: string;
  resume: string;
  systemPrompt?: string;
  prompt?: string;
  createdAt?: Date;
  updatedAt?: Date;
  job?: Job;
  candidate?: Candidate;
  aiGenerated?: boolean;
}

export interface ResumeMessage {
  id?: string;
  sessionId: string;
  senderId?: string;
  status: "streaming" | "status" | "done" | "error";
  type: "binary" | "text" | "json";
  timestamp?: Date;
  role: "user" | "assistant" | "system" | "information" | "warning" | "error";
  content: string;
  extraContext?: ExtraChatContext;
  tunables?: Tunables;
  resume: Resume;
}

export interface RetrievalParameters {
  searchType: "similarity" | "mmr" | "hybrid" | "keyword";
  topK: number;
  similarityThreshold?: number;
  rerankerModel?: string;
  useKeywordBoost: boolean;
  filterOptions?: Record<string, any>;
  contextWindow: number;
}

export interface SalaryRange {
  min: number;
  max: number;
  currency: string;
  period: "hour" | "day" | "month" | "year";
  isVisible: boolean;
}

export interface SearchQuery {
  query: string;
  filters?: Record<string, any>;
  page: number;
  limit: number;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export interface Skill {
  id?: string;
  name: string;
  category: string;
  level: "beginner" | "intermediate" | "advanced" | "expert";
  yearsOfExperience?: number;
}

export interface SkillAssessment {
  candidateId: string;
  skill: string;
  skillModified?: string;
  evidenceFound: boolean;
  evidenceStrength: "strong" | "moderate" | "weak" | "none" | "unknown";
  assessment: string;
  description: string;
  evidenceDetails?: Array<EvidenceDetail>;
  reasoning?: string;
  createdAt?: Date;
  updatedAt?: Date;
  ragResults?: Array<ChromaDBGetResponse>;
  matchScore: number;
}

export interface SkillAssessmentExtraction {
  skillAssessment: SkillAssessmentData;
}

export interface SkillMatchRequest {
  skill: string;
  regenerate: boolean;
}

export interface SocialLink {
  platform: "linkedin" | "twitter" | "github" | "dribbble" | "behance" | "website" | "other";
  url: string;
}

export interface SystemInfo {
  installedRAM: string;
  graphicsCards: Array<GPUInfo>;
  CPU: string;
  llmBackend: string;
  llmModel: string;
  embeddingModel: string;
  maxContextLength: number;
}

export interface Tool {
  toolCalls: Array<Record<string, string>>;
  messages?: Array<any>;
  available?: Array<string>;
  toolName: string;
}

export interface ToolCall {
  name: string;
  content: string;
}

export interface Tunables {
  enableRAG: boolean;
  enableTools: boolean;
  enableContext: boolean;
  temperature: number;
  topK: number;
  threshold?: number;
}

export interface UsageStats {
  promptTokens?: number;
  completionTokens?: number;
  totalTokens?: number;
  promptEvalCount?: number;
  promptEvalDuration?: number;
  evalCount?: number;
  evalDuration?: number;
  totalDuration?: number;
  tokensPerSecond?: number;
  promptTokensPerSecond?: number;
  extraStats?: Record<string, any>;
}

export interface UserActivity {
  id?: string;
  userId?: string;
  guestId?: string;
  activityType: "login" | "search" | "view_job" | "apply_job" | "message" | "update_profile" | "chat";
  timestamp: Date;
  metadata: Record<string, any>;
  ipAddress?: string;
  userAgent?: string;
  sessionId?: string;
}

export interface UserPreference {
  userId: string;
  theme: "light" | "dark" | "system";
  notifications: Array<NotificationPreference>;
  accessibility: AccessibilitySettings;
  dashboardLayout?: Record<string, any>;
  language: string;
  timezone: string;
  emailFrequency: "immediate" | "daily" | "weekly" | "never";
}

export interface WorkExperience {
  id?: string;
  companyName: string;
  position: string;
  startDate: Date;
  endDate?: Date;
  isCurrent: boolean;
  description: string;
  skills: Array<string>;
  location: Location;
  achievements?: Array<string>;
}

export interface SkillAssessmentData {
  skill: string;
  description: string;
  evidenceDetails?: Array<EvidenceDetail>;
  assessment: string;
  evidenceFound: boolean;
  evidenceStrength: string;
}

// ============================
// Date and Nested Model Conversion Functions
// ============================

// These functions convert API responses to properly typed objects
// with Date objects instead of ISO date strings and nested model conversions

/**
 * Convert Analytics from API response
 * Date fields: timestamp
 */
export function convertAnalyticsFromApi(data: any): Analytics {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: new Date(data.timestamp),
  };
}
/**
 * Convert ApiMessage from API response
 * Date fields: timestamp
 */
export function convertApiMessageFromApi(data: any): ApiMessage {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
  };
}
/**
 * Convert ApplicationDecision from API response
 * Date fields: date
 */
export function convertApplicationDecisionFromApi(data: any): ApplicationDecision {
  if (!data) return data;
  
  return {
    ...data,
    // Convert date from ISO string to Date
    date: new Date(data.date),
  };
}
/**
 * Convert Attachment from API response
 * Date fields: uploadedAt
 */
export function convertAttachmentFromApi(data: any): Attachment {
  if (!data) return data;
  
  return {
    ...data,
    // Convert uploadedAt from ISO string to Date
    uploadedAt: new Date(data.uploadedAt),
  };
}
/**
 * Convert AuthResponse from API response
 * Nested models: user (Candidate)
 */
export function convertAuthResponseFromApi(data: any): AuthResponse {
  if (!data) return data;
  
  return {
    ...data,
    // Convert nested Candidate model
    user: convertCandidateFromApi(data.user),
  };
}
/**
 * Convert Authentication from API response
 * Date fields: resetPasswordExpiry, lastPasswordChange, lockedUntil
 * Nested models: refreshTokens (RefreshToken)
 */
export function convertAuthenticationFromApi(data: any): Authentication {
  if (!data) return data;
  
  return {
    ...data,
    // Convert resetPasswordExpiry from ISO string to Date
    resetPasswordExpiry: data.resetPasswordExpiry ? new Date(data.resetPasswordExpiry) : undefined,
    // Convert lastPasswordChange from ISO string to Date
    lastPasswordChange: new Date(data.lastPasswordChange),
    // Convert lockedUntil from ISO string to Date
    lockedUntil: data.lockedUntil ? new Date(data.lockedUntil) : undefined,
    // Convert nested RefreshToken model
    refreshTokens: data.refreshTokens.map((item: any) => convertRefreshTokenFromApi(item)),
  };
}
/**
 * Convert BaseUser from API response
 * Date fields: lastActivity, createdAt, updatedAt, lastLogin
 */
export function convertBaseUserFromApi(data: any): BaseUser {
  if (!data) return data;
  
  return {
    ...data,
    // Convert lastActivity from ISO string to Date
    lastActivity: data.lastActivity ? new Date(data.lastActivity) : undefined,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
    // Convert lastLogin from ISO string to Date
    lastLogin: data.lastLogin ? new Date(data.lastLogin) : undefined,
  };
}
/**
 * Convert BaseUserWithType from API response
 * Date fields: lastActivity
 */
export function convertBaseUserWithTypeFromApi(data: any): BaseUserWithType {
  if (!data) return data;
  
  return {
    ...data,
    // Convert lastActivity from ISO string to Date
    lastActivity: data.lastActivity ? new Date(data.lastActivity) : undefined,
  };
}
/**
 * Convert Candidate from API response
 * Date fields: lastActivity, createdAt, updatedAt, lastLogin, availabilityDate
 * Nested models: experience (WorkExperience), education (Education), certifications (Certification), jobApplications (JobApplication)
 */
export function convertCandidateFromApi(data: any): Candidate {
  if (!data) return data;
  
  return {
    ...data,
    // Convert lastActivity from ISO string to Date
    lastActivity: data.lastActivity ? new Date(data.lastActivity) : undefined,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
    // Convert lastLogin from ISO string to Date
    lastLogin: data.lastLogin ? new Date(data.lastLogin) : undefined,
    // Convert availabilityDate from ISO string to Date
    availabilityDate: data.availabilityDate ? new Date(data.availabilityDate) : undefined,
    // Convert nested WorkExperience model
    experience: data.experience ? convertWorkExperienceFromApi(data.experience) : undefined,
    // Convert nested Education model
    education: data.education ? convertEducationFromApi(data.education) : undefined,
    // Convert nested Certification model
    certifications: data.certifications ? convertCertificationFromApi(data.certifications) : undefined,
    // Convert nested JobApplication model
    jobApplications: data.jobApplications ? convertJobApplicationFromApi(data.jobApplications) : undefined,
  };
}
/**
 * Convert CandidateAI from API response
 * Date fields: lastActivity, createdAt, updatedAt, lastLogin, availabilityDate
 * Nested models: experience (WorkExperience), education (Education), certifications (Certification)
 */
export function convertCandidateAIFromApi(data: any): CandidateAI {
  if (!data) return data;
  
  return {
    ...data,
    // Convert lastActivity from ISO string to Date
    lastActivity: data.lastActivity ? new Date(data.lastActivity) : undefined,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
    // Convert lastLogin from ISO string to Date
    lastLogin: data.lastLogin ? new Date(data.lastLogin) : undefined,
    // Convert availabilityDate from ISO string to Date
    availabilityDate: data.availabilityDate ? new Date(data.availabilityDate) : undefined,
    // Convert nested WorkExperience model
    experience: data.experience ? convertWorkExperienceFromApi(data.experience) : undefined,
    // Convert nested Education model
    education: data.education ? convertEducationFromApi(data.education) : undefined,
    // Convert nested Certification model
    certifications: data.certifications ? convertCertificationFromApi(data.certifications) : undefined,
  };
}
/**
 * Convert CandidateListResponse from API response
 * Nested models: data (Candidate)
 */
export function convertCandidateListResponseFromApi(data: any): CandidateListResponse {
  if (!data) return data;
  
  return {
    ...data,
    // Convert nested Candidate model
    data: data.data ? convertCandidateFromApi(data.data) : undefined,
  };
}
/**
 * Convert CandidateResponse from API response
 * Nested models: data (Candidate)
 */
export function convertCandidateResponseFromApi(data: any): CandidateResponse {
  if (!data) return data;
  
  return {
    ...data,
    // Convert nested Candidate model
    data: data.data ? convertCandidateFromApi(data.data) : undefined,
  };
}
/**
 * Convert Certification from API response
 * Date fields: issueDate, expirationDate
 */
export function convertCertificationFromApi(data: any): Certification {
  if (!data) return data;
  
  return {
    ...data,
    // Convert issueDate from ISO string to Date
    issueDate: new Date(data.issueDate),
    // Convert expirationDate from ISO string to Date
    expirationDate: data.expirationDate ? new Date(data.expirationDate) : undefined,
  };
}
/**
 * Convert ChatMessage from API response
 * Date fields: timestamp
 */
export function convertChatMessageFromApi(data: any): ChatMessage {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
  };
}
/**
 * Convert ChatMessageError from API response
 * Date fields: timestamp
 */
export function convertChatMessageErrorFromApi(data: any): ChatMessageError {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
  };
}
/**
 * Convert ChatMessageRagSearch from API response
 * Date fields: timestamp
 */
export function convertChatMessageRagSearchFromApi(data: any): ChatMessageRagSearch {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
  };
}
/**
 * Convert ChatMessageResume from API response
 * Date fields: timestamp
 * Nested models: resume (Resume)
 */
export function convertChatMessageResumeFromApi(data: any): ChatMessageResume {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
    // Convert nested Resume model
    resume: convertResumeFromApi(data.resume),
  };
}
/**
 * Convert ChatMessageSkillAssessment from API response
 * Date fields: timestamp
 * Nested models: skillAssessment (SkillAssessment)
 */
export function convertChatMessageSkillAssessmentFromApi(data: any): ChatMessageSkillAssessment {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
    // Convert nested SkillAssessment model
    skillAssessment: convertSkillAssessmentFromApi(data.skillAssessment),
  };
}
/**
 * Convert ChatMessageStatus from API response
 * Date fields: timestamp
 */
export function convertChatMessageStatusFromApi(data: any): ChatMessageStatus {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
  };
}
/**
 * Convert ChatMessageStreaming from API response
 * Date fields: timestamp
 */
export function convertChatMessageStreamingFromApi(data: any): ChatMessageStreaming {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
  };
}
/**
 * Convert ChatMessageUser from API response
 * Date fields: timestamp
 */
export function convertChatMessageUserFromApi(data: any): ChatMessageUser {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
  };
}
/**
 * Convert ChatSession from API response
 * Date fields: createdAt, lastActivity
 */
export function convertChatSessionFromApi(data: any): ChatSession {
  if (!data) return data;
  
  return {
    ...data,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert lastActivity from ISO string to Date
    lastActivity: data.lastActivity ? new Date(data.lastActivity) : undefined,
  };
}
/**
 * Convert DataSourceConfiguration from API response
 * Date fields: lastRefreshed
 */
export function convertDataSourceConfigurationFromApi(data: any): DataSourceConfiguration {
  if (!data) return data;
  
  return {
    ...data,
    // Convert lastRefreshed from ISO string to Date
    lastRefreshed: data.lastRefreshed ? new Date(data.lastRefreshed) : undefined,
  };
}
/**
 * Convert Document from API response
 * Date fields: uploadDate, updatedAt
 */
export function convertDocumentFromApi(data: any): Document {
  if (!data) return data;
  
  return {
    ...data,
    // Convert uploadDate from ISO string to Date
    uploadDate: data.uploadDate ? new Date(data.uploadDate) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
  };
}
/**
 * Convert DocumentListResponse from API response
 * Nested models: documents (Document)
 */
export function convertDocumentListResponseFromApi(data: any): DocumentListResponse {
  if (!data) return data;
  
  return {
    ...data,
    // Convert nested Document model
    documents: data.documents.map((item: any) => convertDocumentFromApi(item)),
  };
}
/**
 * Convert DocumentMessage from API response
 * Date fields: timestamp
 * Nested models: document (Document)
 */
export function convertDocumentMessageFromApi(data: any): DocumentMessage {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
    // Convert nested Document model
    document: convertDocumentFromApi(data.document),
  };
}
/**
 * Convert EditHistory from API response
 * Date fields: editedAt
 */
export function convertEditHistoryFromApi(data: any): EditHistory {
  if (!data) return data;
  
  return {
    ...data,
    // Convert editedAt from ISO string to Date
    editedAt: new Date(data.editedAt),
  };
}
/**
 * Convert Education from API response
 * Date fields: startDate, endDate
 */
export function convertEducationFromApi(data: any): Education {
  if (!data) return data;
  
  return {
    ...data,
    // Convert startDate from ISO string to Date
    startDate: new Date(data.startDate),
    // Convert endDate from ISO string to Date
    endDate: data.endDate ? new Date(data.endDate) : undefined,
  };
}
/**
 * Convert Employer from API response
 * Date fields: lastActivity, createdAt, updatedAt, lastLogin
 * Nested models: jobs (Job)
 */
export function convertEmployerFromApi(data: any): Employer {
  if (!data) return data;
  
  return {
    ...data,
    // Convert lastActivity from ISO string to Date
    lastActivity: data.lastActivity ? new Date(data.lastActivity) : undefined,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
    // Convert lastLogin from ISO string to Date
    lastLogin: data.lastLogin ? new Date(data.lastLogin) : undefined,
    // Convert nested Job model
    jobs: data.jobs ? convertJobFromApi(data.jobs) : undefined,
  };
}
/**
 * Convert EmployerResponse from API response
 * Nested models: data (Employer)
 */
export function convertEmployerResponseFromApi(data: any): EmployerResponse {
  if (!data) return data;
  
  return {
    ...data,
    // Convert nested Employer model
    data: data.data ? convertEmployerFromApi(data.data) : undefined,
  };
}
/**
 * Convert Guest from API response
 * Date fields: lastActivity, createdAt, updatedAt, lastLogin
 */
export function convertGuestFromApi(data: any): Guest {
  if (!data) return data;
  
  return {
    ...data,
    // Convert lastActivity from ISO string to Date
    lastActivity: data.lastActivity ? new Date(data.lastActivity) : undefined,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
    // Convert lastLogin from ISO string to Date
    lastLogin: data.lastLogin ? new Date(data.lastLogin) : undefined,
  };
}
/**
 * Convert GuestSessionResponse from API response
 * Nested models: user (Guest)
 */
export function convertGuestSessionResponseFromApi(data: any): GuestSessionResponse {
  if (!data) return data;
  
  return {
    ...data,
    // Convert nested Guest model
    user: convertGuestFromApi(data.user),
  };
}
/**
 * Convert InterviewFeedback from API response
 * Date fields: createdAt, updatedAt
 * Nested models: skillAssessments (SkillAssessment)
 */
export function convertInterviewFeedbackFromApi(data: any): InterviewFeedback {
  if (!data) return data;
  
  return {
    ...data,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
    // Convert nested SkillAssessment model
    skillAssessments: data.skillAssessments ? convertSkillAssessmentFromApi(data.skillAssessments) : undefined,
  };
}
/**
 * Convert InterviewSchedule from API response
 * Date fields: scheduledDate, endDate
 * Nested models: feedback (InterviewFeedback)
 */
export function convertInterviewScheduleFromApi(data: any): InterviewSchedule {
  if (!data) return data;
  
  return {
    ...data,
    // Convert scheduledDate from ISO string to Date
    scheduledDate: new Date(data.scheduledDate),
    // Convert endDate from ISO string to Date
    endDate: new Date(data.endDate),
    // Convert nested InterviewFeedback model
    feedback: data.feedback ? convertInterviewFeedbackFromApi(data.feedback) : undefined,
  };
}
/**
 * Convert Job from API response
 * Date fields: createdAt, updatedAt
 * Nested models: owner (BaseUser), details (JobDetails)
 */
export function convertJobFromApi(data: any): Job {
  if (!data) return data;
  
  return {
    ...data,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
    // Convert nested BaseUser model
    owner: data.owner ? convertBaseUserFromApi(data.owner) : undefined,
    // Convert nested JobDetails model
    details: data.details ? convertJobDetailsFromApi(data.details) : undefined,
  };
}
/**
 * Convert JobAnalysis from API response
 * Nested models: skills (SkillAssessment)
 */
export function convertJobAnalysisFromApi(data: any): JobAnalysis {
  if (!data) return data;
  
  return {
    ...data,
    // Convert nested SkillAssessment model
    skills: data.skills.map((item: any) => convertSkillAssessmentFromApi(item)),
  };
}
/**
 * Convert JobApplication from API response
 * Date fields: appliedDate, updatedDate
 * Nested models: interviewSchedules (InterviewSchedule), decision (ApplicationDecision)
 */
export function convertJobApplicationFromApi(data: any): JobApplication {
  if (!data) return data;
  
  return {
    ...data,
    // Convert appliedDate from ISO string to Date
    appliedDate: new Date(data.appliedDate),
    // Convert updatedDate from ISO string to Date
    updatedDate: new Date(data.updatedDate),
    // Convert nested InterviewSchedule model
    interviewSchedules: data.interviewSchedules ? convertInterviewScheduleFromApi(data.interviewSchedules) : undefined,
    // Convert nested ApplicationDecision model
    decision: data.decision ? convertApplicationDecisionFromApi(data.decision) : undefined,
  };
}
/**
 * Convert JobDetails from API response
 * Date fields: datePosted, applicationDeadline, featuredUntil
 */
export function convertJobDetailsFromApi(data: any): JobDetails {
  if (!data) return data;
  
  return {
    ...data,
    // Convert datePosted from ISO string to Date
    datePosted: data.datePosted ? new Date(data.datePosted) : undefined,
    // Convert applicationDeadline from ISO string to Date
    applicationDeadline: data.applicationDeadline ? new Date(data.applicationDeadline) : undefined,
    // Convert featuredUntil from ISO string to Date
    featuredUntil: data.featuredUntil ? new Date(data.featuredUntil) : undefined,
  };
}
/**
 * Convert JobListResponse from API response
 * Nested models: data (Job)
 */
export function convertJobListResponseFromApi(data: any): JobListResponse {
  if (!data) return data;
  
  return {
    ...data,
    // Convert nested Job model
    data: data.data ? convertJobFromApi(data.data) : undefined,
  };
}
/**
 * Convert JobRequirementsMessage from API response
 * Date fields: timestamp
 * Nested models: job (Job)
 */
export function convertJobRequirementsMessageFromApi(data: any): JobRequirementsMessage {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
    // Convert nested Job model
    job: convertJobFromApi(data.job),
  };
}
/**
 * Convert JobResponse from API response
 * Nested models: data (Job)
 */
export function convertJobResponseFromApi(data: any): JobResponse {
  if (!data) return data;
  
  return {
    ...data,
    // Convert nested Job model
    data: data.data ? convertJobFromApi(data.data) : undefined,
  };
}
/**
 * Convert MessageReaction from API response
 * Date fields: timestamp
 */
export function convertMessageReactionFromApi(data: any): MessageReaction {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: new Date(data.timestamp),
  };
}
/**
 * Convert RAGConfiguration from API response
 * Date fields: createdAt, updatedAt
 * Nested models: dataSourceConfigurations (DataSourceConfiguration)
 */
export function convertRAGConfigurationFromApi(data: any): RAGConfiguration {
  if (!data) return data;
  
  return {
    ...data,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
    // Convert nested DataSourceConfiguration model
    dataSourceConfigurations: data.dataSourceConfigurations.map((item: any) => convertDataSourceConfigurationFromApi(item)),
  };
}
/**
 * Convert RateLimitResult from API response
 * Date fields: resetTimes
 */
export function convertRateLimitResultFromApi(data: any): RateLimitResult {
  if (!data) return data;
  
  return {
    ...data,
    // Convert resetTimes from ISO string to Date
    resetTimes: data.resetTimes ? new Date(data.resetTimes) : undefined,
  };
}
/**
 * Convert RateLimitStatus from API response
 * Date fields: resetTimes
 */
export function convertRateLimitStatusFromApi(data: any): RateLimitStatus {
  if (!data) return data;
  
  return {
    ...data,
    // Convert resetTimes from ISO string to Date
    resetTimes: new Date(data.resetTimes),
  };
}
/**
 * Convert RefreshToken from API response
 * Date fields: expiresAt
 */
export function convertRefreshTokenFromApi(data: any): RefreshToken {
  if (!data) return data;
  
  return {
    ...data,
    // Convert expiresAt from ISO string to Date
    expiresAt: new Date(data.expiresAt),
  };
}
/**
 * Convert Resume from API response
 * Date fields: createdAt, updatedAt
 * Nested models: job (Job), candidate (Candidate)
 */
export function convertResumeFromApi(data: any): Resume {
  if (!data) return data;
  
  return {
    ...data,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
    // Convert nested Job model
    job: data.job ? convertJobFromApi(data.job) : undefined,
    // Convert nested Candidate model
    candidate: data.candidate ? convertCandidateFromApi(data.candidate) : undefined,
  };
}
/**
 * Convert ResumeMessage from API response
 * Date fields: timestamp
 * Nested models: resume (Resume)
 */
export function convertResumeMessageFromApi(data: any): ResumeMessage {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
    // Convert nested Resume model
    resume: convertResumeFromApi(data.resume),
  };
}
/**
 * Convert SkillAssessment from API response
 * Date fields: createdAt, updatedAt
 */
export function convertSkillAssessmentFromApi(data: any): SkillAssessment {
  if (!data) return data;
  
  return {
    ...data,
    // Convert createdAt from ISO string to Date
    createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
    // Convert updatedAt from ISO string to Date
    updatedAt: data.updatedAt ? new Date(data.updatedAt) : undefined,
  };
}
/**
 * Convert UserActivity from API response
 * Date fields: timestamp
 */
export function convertUserActivityFromApi(data: any): UserActivity {
  if (!data) return data;
  
  return {
    ...data,
    // Convert timestamp from ISO string to Date
    timestamp: new Date(data.timestamp),
  };
}
/**
 * Convert WorkExperience from API response
 * Date fields: startDate, endDate
 */
export function convertWorkExperienceFromApi(data: any): WorkExperience {
  if (!data) return data;
  
  return {
    ...data,
    // Convert startDate from ISO string to Date
    startDate: new Date(data.startDate),
    // Convert endDate from ISO string to Date
    endDate: data.endDate ? new Date(data.endDate) : undefined,
  };
}

const _converterTable: Record<string, (data: any) => any> = {
  Analytics: convertAnalyticsFromApi,
  ApiMessage: convertApiMessageFromApi,
  ApplicationDecision: convertApplicationDecisionFromApi,
  Attachment: convertAttachmentFromApi,
  AuthResponse: convertAuthResponseFromApi,
  Authentication: convertAuthenticationFromApi,
  BaseUser: convertBaseUserFromApi,
  BaseUserWithType: convertBaseUserWithTypeFromApi,
  Candidate: convertCandidateFromApi,
  CandidateAI: convertCandidateAIFromApi,
  CandidateListResponse: convertCandidateListResponseFromApi,
  CandidateResponse: convertCandidateResponseFromApi,
  Certification: convertCertificationFromApi,
  ChatMessage: convertChatMessageFromApi,
  ChatMessageError: convertChatMessageErrorFromApi,
  ChatMessageRagSearch: convertChatMessageRagSearchFromApi,
  ChatMessageResume: convertChatMessageResumeFromApi,
  ChatMessageSkillAssessment: convertChatMessageSkillAssessmentFromApi,
  ChatMessageStatus: convertChatMessageStatusFromApi,
  ChatMessageStreaming: convertChatMessageStreamingFromApi,
  ChatMessageUser: convertChatMessageUserFromApi,
  ChatSession: convertChatSessionFromApi,
  DataSourceConfiguration: convertDataSourceConfigurationFromApi,
  Document: convertDocumentFromApi,
  DocumentListResponse: convertDocumentListResponseFromApi,
  DocumentMessage: convertDocumentMessageFromApi,
  EditHistory: convertEditHistoryFromApi,
  Education: convertEducationFromApi,
  Employer: convertEmployerFromApi,
  EmployerResponse: convertEmployerResponseFromApi,
  Guest: convertGuestFromApi,
  GuestSessionResponse: convertGuestSessionResponseFromApi,
  InterviewFeedback: convertInterviewFeedbackFromApi,
  InterviewSchedule: convertInterviewScheduleFromApi,
  Job: convertJobFromApi,
  JobAnalysis: convertJobAnalysisFromApi,
  JobApplication: convertJobApplicationFromApi,
  JobDetails: convertJobDetailsFromApi,
  JobListResponse: convertJobListResponseFromApi,
  JobRequirementsMessage: convertJobRequirementsMessageFromApi,
  JobResponse: convertJobResponseFromApi,
  MessageReaction: convertMessageReactionFromApi,
  RAGConfiguration: convertRAGConfigurationFromApi,
  RateLimitResult: convertRateLimitResultFromApi,
  RateLimitStatus: convertRateLimitStatusFromApi,
  RefreshToken: convertRefreshTokenFromApi,
  Resume: convertResumeFromApi,
  ResumeMessage: convertResumeMessageFromApi,
  SkillAssessment: convertSkillAssessmentFromApi,
  UserActivity: convertUserActivityFromApi,
  WorkExperience: convertWorkExperienceFromApi,
};

/**
 * Generic converter that automatically selects the right conversion function
 * based on the model type
 */
export function convertFromApi<T>(data: any, modelType: string): T {
  if (!data) return data;
  const converter = _converterTable[modelType];
  return (converter ? converter(data) : data) as T;
}

/**
 * Convert array of items using the appropriate converter
 */
export function convertArrayFromApi<T>(data: any[], modelType: string): T[] {
  if (!data || !Array.isArray(data)) return data;
  return data.map(item => convertFromApi<T>(item, modelType));
}
// ============================
// Union Types
// ============================

export type User = Candidate | Employer;

// Export all types
export type { };
